import { Newspaper, ExternalLink, Quote } from "lucide-react";
import { Button } from "./ui/button";
import { siteData } from "../data/mock";

export const NewsSection = () => {
  const article = siteData.newsArticle;

  return (
    <section
      id="press"
      aria-labelledby="press-heading"
      className="py-20 lg:py-28"
      style={{ background: '#FFF9F2' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="font-mono text-[11px] uppercase tracking-widest text-stone-400 block mb-3">
            In The News
          </span>
          <h2
            id="press-heading"
            className="text-3xl sm:text-4xl font-semibold text-[#232323] mb-4 tracking-tight"
            style={{ fontFamily: '"Cormorant Garamond", serif' }}
          >
            Featured Press Coverage
          </h2>
          <p className="text-lg text-stone-500 leading-relaxed">
            Dr. Kang's expertise recognized by major Korean-American media.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative bg-white rounded-2xl border border-stone-100 shadow-sm overflow-hidden">
            <div className="absolute top-0 left-0 w-1.5 h-full bg-[#5E8C61] rounded-l-2xl" aria-hidden="true" />
            
            <div className="p-8 lg:p-10 pl-10 lg:pl-12">
              <div className="flex flex-wrap items-center gap-3 mb-6">
                <span className="bg-[#232323] text-white text-[11px] font-semibold px-3 py-1 rounded-full">
                  {article.source}
                </span>
                <span className="text-sm text-stone-500">{article.date}</span>
              </div>

              <h3
                className="text-xl lg:text-2xl font-semibold text-[#232323] mb-2 leading-snug"
                style={{ fontFamily: '"Cormorant Garamond", serif' }}
              >
                &ldquo;{article.title}&rdquo;
              </h3>
              <p className="text-base text-stone-600 font-medium mb-6">
                {article.titleEn}
              </p>

              <div className="relative bg-[#FFFAF5] rounded-xl p-6 mb-6 border border-stone-100">
                <Quote className="absolute top-4 left-4 w-6 h-6 text-[#DDE8DA]" aria-hidden="true" />
                <blockquote className="pl-8">
                  <p className="text-stone-700 leading-relaxed mb-2 italic">
                    &ldquo;{article.quote}&rdquo;
                  </p>
                  <p className="text-sm text-stone-500">
                    {article.quoteEn}
                  </p>
                </blockquote>
              </div>

              <p className="text-stone-500 leading-relaxed mb-6 text-[15px]">
                {article.summary}
              </p>

              <Button
                asChild
                variant="outline"
                className="border-[#C5D4C0] text-[#5E8C61] hover:bg-[#F0F4ED] hover:border-[#5E8C61] rounded-full px-5 h-10 text-sm font-medium transition-all duration-200"
              >
                <a
                  href={article.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Read full article on Chosun Daily"
                >
                  Read Full Article
                  <ExternalLink className="ml-1.5 w-3.5 h-3.5" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
